export default __webpack_public_path__ + "static/media/role.c0074045.mp3";